import { render, staticRenderFns } from "./mFooterBar.vue?vue&type=template&id=0d8df175&"
import script from "./mFooterBar.vue?vue&type=script&lang=js&"
export * from "./mFooterBar.vue?vue&type=script&lang=js&"
import style0 from "./mFooterBar.vue?vue&type=style&index=0&id=0d8df175&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports